import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoDecimals]'
})
export class NoDecimalsDirective {

  @HostListener('input', ['$event'])
  onInput(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/[^0-9,]/g, ''); 
    value = value.replace(/,/g, '');
    const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    input.value = formattedValue;
    
  }
}